module.exports = __webpack_public_path__ + "assets/fc0a07ae2ef63e125a6b017a9c36de3c.png";